import React, { FC } from 'react'
import * as Yup from 'yup'
import { Button, Grid, Box, CircularProgress } from '@mui/material'
import { Formik, Form } from 'formik'
import { FormCheckbox, TextField } from 'src/components/ui'

const getValidationSchema = (isRequired: boolean = true) => Yup.object().shape({
  displayName: isRequired ? Yup.string().required('Value is required') : Yup.string(),
})

interface TypeNewState {
  displayName: string
  description?: string
  order?: number
  divider?: boolean
}

const defaultInitial: TypeNewState = {
  displayName: '',
  description: undefined,
  order: undefined,
  divider: false,
}

export interface TypeNewFormProps {
  placeholder?: string
  initialValues?: TypeNewState | null;
  label?: string | null;
  isRequiredField?: boolean;
  isLoading?: boolean;
  needToResetForm?: boolean;
  onSubmit: (formState: TypeNewState) => void;
  onCancel?: () => void;
}

export const TypeNewForm: FC<TypeNewFormProps> = ({
  initialValues,
  placeholder,
  label,
  isRequiredField = true,
  isLoading = false,
  needToResetForm = true,
  onSubmit,
  onCancel,
}) => {
  const validationSchema = getValidationSchema(isRequiredField)
  return (
    <Formik
      initialValues={{ ...defaultInitial, ...initialValues }}
      onSubmit={(data, { resetForm }) => {
        onSubmit(data)
        if (needToResetForm) resetForm()
      }}
      validationSchema={validationSchema}
    >
      <Form>
        <Grid container spacing={4} direction="row" flexWrap="wrap">
          <Grid item flexGrow={1}>
            <TextField
              name="displayName"
              label={label || "Name"}
              required={isRequiredField}
              TextFieldProps={{ placeholder }}
            />
          </Grid>
          {
            initialValues?.description !== undefined
              ? (<Grid item flexGrow={1}>
                <TextField
                  name="description"
                  label="Description"
                  TextFieldProps={{ placeholder: 'Description' }}
                />
              </Grid>)
              : null
          }
          {
            initialValues?.order !== undefined
              ? (<Grid item flexGrow={1}>
                <TextField
                  name="order"
                  label="Order"
                  TextFieldProps={{ placeholder: 'Order', type: "number" }}
                />
              </Grid>)
              : null
          }
          {
            initialValues?.divider !== undefined
              ? (<Grid item flexGrow={1}>
                <FormCheckbox
                  name="divider"
                  label="Divider after item"
                  view="switch"
                />
              </Grid>)
              : null
          }
          <Grid item flexShrink={0}>
            <Grid container spacing={1}>
              <Grid item>
                <Box pt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={isLoading}
                  >
                    {
                      isLoading ? <CircularProgress color="info" size={26} /> : 'Save'
                    }
                  </Button>
                </Box>
              </Grid>
              {onCancel && <Grid item>
                <Box pt={2}>
                  <Button
                    variant="outlined"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>}
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  )
}
